import { createClient } from "@supabase/supabase-js";
import { getOrCreatePlayerId } from "./utils";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

export async function getPlayerSessionsList(playerId) {
  const { data, error } = await supabase.rpc('get_active_player_sessions', {
    p_player_id: playerId
  });

  if (error) {
    console.error("Error fetching player sessions:", error.message);
    return [];
  }

  // Map the snake_case SQL results to your preferred camelCase frontend keys
  return (data || []).map(session => ({
    sessionId: session.session_id,
    playersNum: parseInt(session.players_num),
    gameName: session.game_name,
    stage: session.stage,
    isStarted: session.is_started
  }));
}

export async function getTotalGamesCount() {
  const { data, error } = await supabase
    .from('global_stats')
    .select('total_games_played')
    .single();

  if (error) return 0;
  return data.total_games_played;
}

export async function createGame(gameSettings, gameId) {
  const { data, error } = await supabase.rpc("create_full_game", {
    p_game_data: gameSettings,
    p_session_id: gameId
  });

  if (error) {
    console.error("❌ Failed to create game:", error);
  }

  return data;
}

export async function joinGame(sessionId, playerName) {
  const playerId = getOrCreatePlayerId();

  if (!playerId) {
    console.error("Player ID is missing. Cannot join game.");
    return null;
  }

  const { data: joinedSessionId, error } = await supabase.rpc(
    "join_game_with_id",
    {
      p_session_id: sessionId,
      p_player_id: playerId,
      p_player_name: playerName,
    }
  );

  if (error) {
    console.error("Error joining game:", error);
    return null;
  }

  return joinedSessionId;
}

export async function getGameSettings(sessionId) {
  const { data, error } = await supabase
    .from("game_settings")
    .select("*")
    .eq("session_id", sessionId)
    .single();

  if (error) {
    console.error("Error fetching game settings:", error);
    return null;
  }

  return data;
}

export async function togglePlayerReady(sessionId, playerId) {
  // Call the SQL function 'toggle_player_ready'
  const { data, error } = await supabase
    .rpc('toggle_player_ready', {
      p_player_id: playerId,
      p_session_id: sessionId
    });

  if (error) {
    console.error("Error toggling player ready state:", error.message);
    return null;
  }

  return data;
}


export async function swapCards(sessionId, playerId, handCardId, tableCardId) {
  const { data: success, error } = await supabase.rpc('swap_card_by_id', {
    p_session_id: sessionId,
    p_player_id: playerId,
    p_hand_card_id: handCardId,
    p_table_card_id: tableCardId
  });

  if (error || !success) {
    console.log("Swap blocked or failed:", error);
    return false;
  }

  return true;
}


export async function endGame(sessionId, playerId, guess, doubleScore) {
  if (!guess && doubleScore) return;

  const { error } = await supabase.rpc('handle_end_game', {
    p_session_id: sessionId,
    p_calling_player_id: playerId,
    p_guess: guess,
    p_double_score: doubleScore
  });

  if (error) {
    console.error("End game logic failed:", error.message);
  }
}

export const handleAnswer = async (sessionId, playerId, answerIndex) => {
  const { error } = await supabase.rpc('submit_question_answer', {
    p_session_id: sessionId,
    p_player_id: playerId,
    p_answer_index: answerIndex
  });

  if (error) console.error("Error submitting answer:", error.message);
};


